<script>
import childrenNames from '@/mixins/childrenNames';
import {hasEditPermission,currentRoleLevelName,trialActiveForClients} from '@/mixins/roleLevelPermissions';
import { mapState } from 'vuex';

export default {
	mixins: [childrenNames],
	props: ['agreementData','hideForEdit','itemIndexToShow','forceAddNewItem'],
	computed: {
		...mapState(['currentRoleLevel']),
		accounts() {
			return this.agreementData.pensions;
			// return this.agreementData.pensions = this.agreementData.pensions.map((pension)=>{
			// 	return pension.hasOwnProperty('additionalClausesToRecitals') ? pension  : {...pension, additionalClausesToRecitals: []};
			// });		
		},
		clientUserAgreement(){
			return trialActiveForClients() || currentRoleLevelName === 'client-sharing-user';
		},
		isUserSeparatingParty(){
			return this.currentRoleLevel.roleAssociated === 'party'
		},
		dynamicQuestions(){
			if(this.isUserSeparatingParty){
				return {
					partiesAssignValue: "Do you want to assign a value to the pension?",
					obtainedValuation: "Did you get a professional pension valuation?"
				}
			}
			else{
				return {
					partiesAssignValue: "Do the parties wish to assign a value to the pension?",
					obtainedValuation: "Did the parties obtain a valuation of the pension?"
				}
			}
		}
	},
	methods: {
		newAccount() {
			return {
				exclusions: [],
				additionalClauses: [],
				additionalClausesToRecitals:[]
			};
		},
	},
	data(){
		return{
			// toolTipForDisabledField : this.hideForEdit ? 'This value can be only changed from the builder. Please edit it from the buider page' : '',
			isViewMode : !hasEditPermission('section-property'),
			showLearnButton: ['client-level-1', 'client-level-2'].includes(currentRoleLevelName)
		}
	},
	mounted(){
		for (let i = 0; i < this.agreementData.pensions.length; i++) {
			const pension = this.agreementData.pensions[i];
			if (!pension.hasOwnProperty('additionalClausesToRecitals')) {
				this.$set(pension, 'additionalClausesToRecitals', []);
			}
		}
	}
};
</script>

<template>
	<b-card>
		<div slot="header" class="section-heading">
			<h4>Pensions</h4>
			<a href="#" onclick="Intercom('showArticle', 11106849)" v-if="this.showLearnButton">Learn &nbsp;<b-icon-book/></a>
		</div>

		<list-item
			v-slot="{ item: account, index: index }"
			v-model="accounts"
			:object-prototype="newAccount"
			:testid="'pension-'"
			:hideAddBtn=hideForEdit
			:isEditView=hideForEdit
			:itemIndexToShow=itemIndexToShow
			:forceAddNewItem=forceAddNewItem
			:disabled="isViewMode"
		>
		<template v-if="!forceAddNewItem || (forceAddNewItem && index == (accounts.length-1))">
			<input-group
				v-model="account.name"
				class="mb-2"
				input-cols="8"
				label="Name of pension"
				reset-undefined
				placeholder="ie: Public Service Pension"
				:testid="'pension-name-'+index"
				:disabled="isViewMode"
			/>

			<radio-group
				v-model="account.ownership"
				class="my-3"
				:agreement-data="agreementData"
				input-cols="4"
				label="How is the pension owned?"
				reset-undefined
				partner
				select
				:testid="'pension-ownership-'+index"
				:length="'long'"
				:disabled="isViewMode"
			/>

			<radio-group
				v-model="account.planType"
				class="my-2"
				input-cols="4"
				label="What type of pension plan?"
				reset-undefined
				select
				:options="[
					{ text: 'Extraprovincial', value: 'extraprovincial' },
					{ text: 'Local', value: 'local' },
				]"
				:testid="'pension-plan-type-'+index"
				:disabled="isViewMode"
				:toolTipText="`A 'Local' pension means a pension based in the province, such as
				a Public Service Pension, Municipal Pension, Teacher's Pension. An
				'extraprovincial' pension means either a federal pension or a pension based in
				another province or country.`"
			/>
		    <template v-if="!clientUserAgreement">
			<yes-no-choice
				v-model="account.partiesAssignValue"
				reset-undefined
				:label="dynamicQuestions.partiesAssignValue"
				class="my-3"
				:testid="'pension-parties-assign-value-'+index"
				:disabled="isViewMode"
				:toolTipText="`You do not need to assign a value. You may simply divide the
				Pension in accordance with the <i>Family Law Act</i> and the non-owning spouse will
				become a limited member of the Pension and receive the correct portion of the
				pension upon retirement. Unless you are balancing the value of the pension
				against other assets, or you have a great deal of funds available to buy your
				spouse out, most people do not value and buyout their spouse's portion of the
				pension.`"
			/>

			<conditional-group
				class="my-3"
				:condition="account.partiesAssignValue"
			>
				
				<yes-no-choice
					v-model="account.obtainedValuation"
					reset-undefined
					:label="dynamicQuestions.obtainedValuation"
					class="my-3"
					:testid = "'pension-conditions-'+index"
					:disabled="isViewMode"
					:toolTipText="`Your pension statement will typically not outline the value of
					the pension as an asset. Instead it will show the value of the future payouts
					you'll receive and the value of your contributions. Neither of these represents
					the true value. An Actuarial Accountant (Actuary) will review your pension and
					provide the Net Present Value of the expected pension payouts you'll receive in
					retirement. The Actuary will also provide the proportional value accumulated in
					the relationship. This value is often significantly different than the value of
					the contributions and it's highly recommended to get assistance determining this
					value.`"
				/>

				<input-group
					v-model="account.value"
					reset-undefined
					class="my-3"
					dollar
					label="What is the value of the pension?"
					:testid="'pension-value-'+index"
					:disabled="isViewMode"
				/>

					<radio-group
					v-model="account.orderOfTax"
					class="my-2"
					input-cols="4"
					label="Is this a before-tax or after-tax value?"
					reset-undefined
					select
					:options="[
						{ text: 'before-tax value', value: 'before-tax' },
						{ text: 'after-tax value', value: 'after-tax' },
					]"
					:testid="'order-of-tax-'+index"
					:disabled="isViewMode"
					:toolTipText="`The Pension Valuation prepared by the Actuary will outline
					different types of numbers. Use the before-tax value to balance the pension
					against other before-tax assets like RRSPs. Use the after-tax value to compare
					to after-tax assets like real estate and other financial accounts.`"
				/>
				</conditional-group>
				<radio-group
					v-model="account.plan"
					class="my-3"
					input-cols="10"
					label="What will the owner do with the pension upon separation?"
					reset-undefined
					select
					:options="[
						{
							text: `Owner will keep, and the other ${isUserSeparatingParty? 'person': 'party'} will waive their interest`,
							value: 'keep',
						},
						{
							text: 'Divide, in accordance with the Family Law Act',
							value: 'divide',
						},
					]"
					:testid="'pension-upon-separation-'+index"
					:length="'long'"
					:disabled="isViewMode"
					:toolTipText="`Most people choose to Divide the Pension in accordance with the
				<i>Family Law Act</i>, which means that each spouse will receive separate payments upon
				retirement. Alternatively, if you've chosen to value the pension, you can opt to
				have the owner keep the pension and the non-owner will waive their right to the
				pension. The value will be considered and balanced against other assets, but the
				actual pension will be retained, in full, by the owner. A last option is to have
				the owner keep the pension and the non-owner will waive their right to the
				pension even when you do not assign a value to the pension. This last option is
				a full waiver of the pension. It is generally advised to obtain a value if you
				are considering this, so that both spouses know what they are agreeing to
				keep/waive.`"
			/>

				<additional-clauses :title="'Additional Clauses into Recitals'" :newLabel="'Add Clause to Recitals'" class="mt-2" v-model="account.additionalClausesToRecitals" :testid="'pension-add-clause-to-recitals-'+index+'-'"
					:disabled="isViewMode"/>
				<additional-clauses :title="'Additional Clauses into Sections'" :newLabel="'Add Clause to Section'" class="mt-2" v-model="account.additionalClauses" :testid="'pension-add-clause-'+index+'-'"
					:disabled="isViewMode"/>
			</template>
		</template>
		</list-item>
	</b-card>
</template>
